import { MoreVerticalOutlineIcon } from '@carboncopyco/icons';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { ColorHex } from '@carboncopyco/ui';
import { useTabManager } from '../../services/TabManager';
import AppInnerTabs from './AppInnerTabs';

const InnerTabsContainer = ({ globalTab }: { globalTab: IGlobalTab }) => {
  const { navigateInnerTab, closeInnerTab } = useTabManager();
  const isWindows = window?.dsDesktop?.app?.isWindows;

  const handleTabSwitch = (id: number) => {
    const innerTab = globalTab?.innerTabs?.find((tab) => tab.id === Number(id));
    if (innerTab) {
      navigateInnerTab(innerTab, globalTab);
    }
  };

  const InnerTabItems = (globalTab.innerTabs || []).map((tab) => ({
    id: tab.id,
    title: tab.url,
    hoverTitle: tab.url,
  }));

  if (globalTab.innerTabs?.length <= 1 || !globalTab.activeInnerTabId)
    return null;

  return (
    <AppInnerTabs
      items={InnerTabItems}
      activeTabId={globalTab.activeInnerTabId}
      onTabClick={handleTabSwitch}
      onTabClose={closeInnerTab}
      moreTabsDropdownIcon={
        isWindows && <MoreVerticalOutlineIcon color={ColorHex.natural50} />
      }
    />
  );
};

export default InnerTabsContainer;
